export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9116.5dd0064c.jpg";